import Vue from "vue";
import Vuex from "vuex";

import ApiService from "../../ceres/services/ApiService";

// import address from "../../ceres/store/modules/AddressModule";
import basket from "./modules/BasketModule";
import checkout from "./modules/CheckoutModule";
import consents from "./modules/ConsentModule";
// import contactForm from "../../ceres/store/modules/ContactFormModule";
import itemList from "./modules/ItemListModule";
import itemSearch from "../../ceres/store/modules/ItemSearchModule";
// import lastSeen from "../../ceres/store/modules/LastSeenModule";
import lazyComponent from "../../ceres/store/modules/LazyComponentModule";
// import liveShopping from "../../ceres/store/modules/LiveShoppingModule";
import localization from "./modules/LocalizationModule";
import navigation from "../../eros/store/modules/NavigationModule";
// import orderReturn from "../../ceres/store/modules/OrderReturnModule";
import user from "../../ceres/store/modules/UserModule";
// import wishList from "../../ceres/store/modules/WishListModule";
// import items from "./modules/singleItem/BaseItemModule";
import CategoryItemSiblings from "./modules/CategoryItemSiblings";
// import DynamicItemList from "./modules/dynamicItemList/BaseDynamicItemListModule";
import UserAnalytics from "./modules/UserAnalytics";
// import OrderConfirmation from "./modules/OrderConfirmationModule";
import ConsentFunctionQueue from "./modules/ConsentFunctionQueueModule";
import exchangeRatios from "./modules/ExchangeRatios";
// import FeedbackModule from "../plugins/plentymarkets/feedback/store/FeedbackModule";
import AbtestModule from "./modules/AbtestModule";

import { getUrlParams } from "../../ceres/services/UrlService";
import TranslationService from "../../ceres/services/TranslationService";
import NotificationService from "../../ceres/services/NotificationService";

import eventPropagation from "../../ceres/store/plugins/EventPropagationPlugin";
import { isDefined } from "../../ceres/helper/utils";
import { abTestCookieCheck } from "../helper/abTestCookieCheck";

export let store;

// TODO: add code comment
export function createStore() {
	if (App.Eros.Config.general.benchmarkJS) console.time("App.eros.store: createStore"); // eslint-disable-line no-console
	// =========================
	// init vuex store
	// =========================

	Vue.options.delimiters = ["${", "}"];
	Vue.use(Vuex);

	// eslint-disable-next-line
	store = new Vuex.Store({
		modules: {
			// address,
			basket,
			checkout,
			consents,
			// contactForm,
			itemList,
			// items,
			itemSearch,
			// lastSeen,
			lazyComponent,
			// liveShopping,
			localization,
			navigation,
			// orderReturn,
			user,
			// wishList,
			UserAnalytics,
			CategoryItemSiblings,
			// DynamicItemList,
			// OrderConfirmation,
			ConsentFunctionQueue,
			exchangeRatios,
			// FeedbackModule,
			AbtestModule
		},

		plugins: !App.isSSR ? [eventPropagation] : [] });

	if (App.Eros.Config.general.benchmarkJS) console.timeEnd("App.eros.store: createStore"); // eslint-disable-line no-console

	return store;
}

// TODO: add code comment
export function initServerStore(store) {
	if (App.Eros.Config.general.benchmarkJS) console.time("App.eros.store: initServerStore"); // eslint-disable-line no-console
	store.commit("setShippingCountries", App.initialData.shippingCountries);
	store.commit("setShippingCountryId", App.initialData.shippingCountryId);
	store.commit("setShowNetPrices", App.initialData.showNetPrices);
	if ( App.initialData.euShippingCountries) {
        store.commit("setEuShippingCountries", App.initialData.euShippingCountries);
    }
	if (App.Eros.Config.general.benchmarkJS) console.timeEnd("App.eros.store: initServerStore"); // eslint-disable-line no-console
}

// TODO: add code comment
export function initClientListeners(store) {
	if (App.Eros.Config.general.benchmarkJS) console.time("App.eros.store: initClientListeners"); // eslint-disable-line no-console
	ApiService.listen("LocalizationChanged", data => {
		store.commit("setShippingCountries", data.localization.activeShippingCountries);
		store.commit("setShippingCountryId", data.localization.currentShippingCountryId);
	});

	ApiService.listen("AfterBasketChanged", data => {
		store.commit("setBasket", data.basket);
		store.commit("setShowNetPrices", data.showNetPrices);
		store.commit("updateBasketItems", data.basketItems);
		// store.commit("setWishListIds", data.basket.itemWishListIds);
	});

	ApiService.listen("AfterBasketItemAdd", data => {
		store.commit("addBasketItem", data.basketItems);
	});

	ApiService.listen("AfterBasketItemUpdate", data => {
		store.commit("updateBasketItem", data.basketItems[0]);
	});

	ApiService.after(() => {
		// unset flag that indicates a basket item quantity update after each request.
		store.commit("setIsBasketItemQuantityUpdate", false);
	});

	/**
	 * Adds login/logout event listeners
	 */
	ApiService.listen("AfterAccountAuthentication", userData => {
		store.commit("setUserData", userData.accountContact);
	});
	ApiService.listen("AfterAccountContactLogout", () => {
		store.commit("setUserData", null);
	});
	if (App.Eros.Config.general.benchmarkJS) console.timeEnd("App.eros.store: initClientListeners"); // eslint-disable-line no-console
}

// TODO: add code comment
export function initClientStore(store) {
	if (App.Eros.Config.general.benchmarkJS) {
		console.time("App.eros.store: initClientStore"); // eslint-disable-line no-console
	}

	if (App.Eros.Config.general.benchmarkJS) {
		console.time("App.eros.store: initClientStore-->AbtestModule/checkCookie"); // eslint-disable-line no-console
	}

	store.dispatch("AbtestModule/checkCookie");

	if (App.Eros.Config.general.benchmarkJS) {
		console.timeEnd("App.eros.store: initClientStore-->AbtestModule/checkCookie"); // eslint-disable-line no-console
	}

	if (App.Eros.Config.general.benchmarkJS) {
		console.time("App.eros.store: initClientStore-->initConsents"); // eslint-disable-line no-console
	}
	store.dispatch("initConsents");
	if (App.Eros.Config.general.benchmarkJS) {
		console.timeEnd("App.eros.store: initClientStore-->initConsents"); // eslint-disable-line no-console
	}

	if (App.Eros.Config.general.benchmarkJS) {
		console.time("App.eros.store: initClientStore-->runIfConsented(getSession)"); // eslint-disable-line no-console
	}

	// Use DOMContentLoaded to load session data after app has been initialized
	document.addEventListener("DOMContentLoaded", () => {
		const urlParams = getUrlParams();

		if (store.getters.currentItemVariation) {
			urlParams.lastSeenVariationId = store.getters.currentItemVariation.variation.id;
		}
		store.dispatch("runIfConsented", () => {
			ApiService.get("/rest/erosbackend/session", urlParams, { cache: false, keepOriginalResponse: true })
				.done(response => {
					if (isDefined(response.data.customer)) {
						store.commit("setUserData", response.data.customer);
					}

					if (!response.events.hasOwnProperty("AfterBasketChanged")) {
						// only set basket if not change event is emitted. In this case, the basket will be set by the event listener.
						store.commit("setBasket", response.data.basket);
						// store.commit("setWishListIds", response.data.basket.itemWishListIds);
					}

					abTestCookieCheck(response, store);

					store.commit("setIsBasketInitiallyLoaded");
					store.commit("setBasketItems", response.data.basketItems);
					window.dispatchEvent(new Event("session-called"));
				})
				.catch((error, status) => {
					console.log(error, status); // eslint-disable-line no-console

					if (status > 0) {
						NotificationService.error(
							TranslationService.translate("Ceres::Template.basketOops")
						).closeAfter(10000);
					}
				});
		});
	});

	if (App.Eros.Config.general.benchmarkJS) {
		console.timeEnd("App.eros.store: initClientStore-->runIfConsented(getSession)"); // eslint-disable-line no-console
	}

	if (App.Eros.Config.general.benchmarkJS) {
		console.timeEnd("App.eros.store: initClientStore"); // eslint-disable-line no-console
	}
}

export default { createStore, initServerStore, initClientListeners, initClientStore, store };
